import { Component, Inject, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { OshWave } from '../../../../../interfaces/osh/oshWave';
import { OshWaveBranchConfig } from '../../../../../interfaces/osh/oshWaveBranchConfig';
import { OshAssignBranchPopupComponent } from './assignbranchpopup/assignbranchpopup.component';

@Component({
    selector: 'osh-wavebranchconfig',
    templateUrl: './wavebranchconfig.component.html',
    styleUrls: ['./wavebranchconfig.component.less',
        '../oshadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class OshWaveBranchConfigComponent implements OnChanges, OnDestroy {
    public dataSource = new MatTableDataSource<OshWaveBranchConfig>();

    @Input() selectedWave: OshWave | undefined;
    columnsToDisplay = ['Checkbox', 'mgmtId', 'mgmtName'];

    isRemoveAssignmentEnabled = false;
    removeBranchesList: string[] = []

    private readonly _onDestroy = new Subject<void>();
    private lastWaveId: number = -1;
    
    constructor(
        private readonly http: HttpClient
        , private readonly dialogForm: MatDialog
        , @Inject('BASE_URL') private readonly baseUrl: string
        , private readonly toastrService: ToastrService
        , public defaults: DefaultValuesService) { }

    
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedWave'] && this.selectedWave?.id !== this.lastWaveId) {
            this.lastWaveId = this.selectedWave?.id ?? -1;
            this.reload();
        }
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    reload() {
        if (this.selectedWave && this.selectedWave?.id !== -1)
            Utils.httpGetOshWaveBranchConfigurations(
                this.http,
                this.baseUrl,
                this.selectedWave.id,
                this,
                function (tthis: OshWaveBranchConfigComponent, list: any) {
                    tthis.dataSource.data = list
                    tthis.isRemoveAssignmentEnabled = false;
                    tthis.removeBranchesList = [];
                }
            )
    }

    openAssignBranchPopup() {
        const dialog = this.dialogForm.open(OshAssignBranchPopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            minWidth: "60vw",
            data: this.selectedWave
        })

        dialog.afterClosed().subscribe(() => {
            this.reload()
        })
    }

    enableRemoveAssignmentMode() {
        this.isRemoveAssignmentEnabled = !this.isRemoveAssignmentEnabled;
        if (this.isRemoveAssignmentEnabled)
            this.removeBranchesList = [];
    }

    controlAssignedItem(ischecked: boolean, row?: any) {
        if (row) {
            if (ischecked) {
                this.removeBranchesList.push(row.mgmtId);
                return;
            }
            const index = this.removeBranchesList.indexOf(row.mgmtId);
            if (index !== -1) {
                this.removeBranchesList.splice(index, 1);
            }
            return;
        }
        this.removeBranchesList = ischecked
            ? (this.dataSource.data ?? []).map((x: any) => x.mgmtId)
            : [];
    }

    isAllSelected(): boolean {
        const total = this.dataSource.data?.length ?? 0;
        return total > 0 && this.removeBranchesList.length === total;
    }

    isPartiallySelected(): boolean {
        return this.removeBranchesList.length > 0 && !this.isAllSelected();
    }

    confirmRemoveAssignedBranches() {
        Utils.httpUnassignOshWaveBranchConfigurations(
            this.http,
            this.baseUrl,
            this.selectedWave!.id,
            this.removeBranchesList,
            this,
            function (tthis: OshWaveBranchConfigComponent, result: any) {
                if (result)
                    tthis.toastrService.success('Branches were unassigned successfully!');
                else
                    tthis.toastrService.error('Branches could not be unassigned. Please, contact with administrator');
                tthis.reload();
            }
        )
    }
}
// using centralized interfaces

